/** Rewrote by Wave Commerce **/
/** Combined with doubletaptogo **/
/**
 * jquery.slimmenu.js
 * http://adnantopal.github.io/slimmenu/
 * Author: @adnantopal
 * Copyright 2013-2015, Adnan Topal (adnan.co)
 * Licensed under the MIT license.
 */
(function ($, window, document, undefined) {
  "use strict";

  var iconHamburger = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></svg>';
  var iconRight = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>Right</title><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
  var iconDown = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>';
  var pluginName = 'slimmenu',
    oldWindowWidth = 0,
    defaults = {
      resizeWidth: '1',
      initiallyVisible: false,
      collapserTitle: 'Main Menu',
      animSpeed: 'medium',
      easingEffect: null,
      expandIcon: '<i>' + iconRight + '</i>',
      collapseIcon: '<i>' + iconRight + '</i>'
    },
    showMenuTimeout,
    preventClick = false,
    preventShowMenu = false,
    currentTap = $();

  function Plugin(element, options) {
    this.element = element;
    this.$elem = $(this.element);
    this.options = $.extend(defaults, options);
    this.init();

  }

  Plugin.prototype = {
    init: function () {
      oldWindowWidth = 0;
      var $window = $(window),
        options = this.options,
        $menu = this.$elem,
        $collapser = '<div class="menu-collapser">' + options.collapserTitle + '<div class="collapse-button"><span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span></div></div>',
        $menuCollapser;

      this.resizeMenu();
    },
    resizeMenu: function () {
      var self = this,
        $window = $(window),
        windowWidth = $window.width(),
        $options = this.options,
        $menu = $(this.element);

      if (window['innerWidth'] !== undefined) {
        if (window['innerWidth'] > windowWidth) {
          windowWidth = window['innerWidth'];
        }
      }

      if (windowWidth != oldWindowWidth) {
        oldWindowWidth = windowWidth;

        $menu.find('li').each(function () {
          var $parentLi = $(this).closest('li');
          var icon = '<i>' + iconRight + '</i>';
          if ($parentLi.hasClass('main-categories')) {
            icon = '<i>' + iconHamburger + '</i> Menu';
          }

          if ($(this).has('ul').length) {
            if ($(this).addClass('has-submenu').has('.sub-toggle').length) {
              $(this).children('.sub-toggle').html(icon);
            } else {
              $(this).addClass('has-submenu').append('<span class="sub-toggle">' + icon + '</span>');
            }
          }

          $(this).children('ul').hide().end().find('.sub-toggle').removeClass('expanded').html(icon);
        });

        function showMenu($el) {
          $('body').addClass('open-main-nav');
          preventShowMenu = true;
          var $first_menu = $menu.find('.first-menu'),
            first_top = $menu.find('.main-categories').offset().top,
            this_top = $el.offset().top,
            margin_top = (first_top < this_top ? first_top - this_top + $menu.find('.main-categories a').outerHeight() : 0);

          var animSpeed = 0;
          var $ul = $el.find('>ul');
          if ($el.hasClass('main-categories')) {
            animSpeed = 125;
          }
          // $ul.css('margin-top', margin_top).stop().slideDown(animSpeed);
          // TODO: animations
          $ul.stop().show()

          if ($el.hasClass('main-categories')) {
            setTimeout(function() {
              $ul.find('.first-menu-inner').css('overflow-y', 'auto');
            }, animSpeed);
          }
        }
        function hideMenu($el) {
          var animSpeed = 0;
          var $ul = $el.find('ul');
          if ($el.hasClass('main-categories')) {
            animSpeed = 125;

            $ul.find('.first-menu-inner').css('overflow-y', 'hidden');
          }
          // TODO: animations
          $ul.stop().hide();
        }
        function closeMainNav() {
          const $el = $menu.find('.main-categories');
          const $ul = $el.find('ul');
          $ul.find('.first-menu__inner').css('overflow-y', 'hidden');
          // TODO: animations
          $ul.stop().hide();
          $('body').removeClass('open-main-nav');
        }
        $menu.find('.main-nav-back').on('click', function() {
          event.preventDefault();
          event.stopPropagation();

          closeMainNav();
        });
        $('.close-main-menu').on('click', function() {
          event.preventDefault();
          event.stopPropagation();

          closeMainNav();
        });

        $('html').on('touchstart', function(event) {
          if(windowWidth >= 768 && $(event.target).parents('#main-navigation-menu').length == 0) {
            hideMenu($menu.find('li'));
          }
        });

        $menu.find('.first-menu-item.has-submenu')
          .on('touchstart', function(event) {
            event.stopPropagation();
            var $target = $(event.target).closest('li');

            if (!$target.hasClass('has-submenu')) {
              preventClick = false;
              return true;
            }
            if ($target.get(0) === currentTap.get(0)) {
              preventClick = false;
              return true;
            }
            preventClick = true;
            preventShowMenu = false;
            currentTap = $target;
          })
          .on('touchmove', function(event) {
            event.stopPropagation();
            preventShowMenu = true;
          })
          .on('touchend', function(event) {
            event.stopPropagation();
            if (!preventShowMenu) {
              var $target = $(event.target).closest('li');
              showMenu($target);
              preventShowMenu = false;

              var $siblings = $(this).siblings('li');
              for (var i = 0; i < $siblings.length; i++) {
                hideMenu($siblings.eq(i));
              }
            }
          })
          .on('mouseenter', function(event) {
            event.preventDefault();
            event.stopPropagation();

            var $siblings = $(this).siblings('li');
            for (var i = 0; i < $siblings.length; i++) {
              hideMenu($siblings.eq(i));
            }
            if ($(this).has('ul')) {
              showMenu($(this));
            }
          })
          .on('mouseleave', function(event) {
            event.stopPropagation();
            event.preventDefault();

            // logic to check scrollbar

            hideMenu($(this));
          })
          .on('click', function(event) {
            event.stopPropagation();
            if (preventClick) {
              event.preventDefault();
            } else {
              currentTap = $();
            }
          })
          .on('mousewheel DOMMouseScroll scroll', function(event) {
            event.stopPropagation();
          });

        $menu.on('click', 'li.main-categories > .sub-toggle', function(event) {
          event.preventDefault();
          event.stopPropagation();

          showMenu($('li.main-categories'));
        });


        $menu.find('li > a > i').remove();
        $menu.removeClass('collapsed').show();
      }
    },
  };

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };

  const $firstMenu = $('.first-menu__inner');
  function handleFirstMenuScroll() {
    const footerOffsetTop = $('.main-nav__footer').offset().top - $('.first-menu').offset().top;
    const offsetTop = $firstMenu.offset().top - $('.first-menu').offset().top;
    const scrollTop = $firstMenu.scrollTop();
    const outerHeight = $firstMenu.find('.first-menu__scroller').outerHeight();

    if (offsetTop + outerHeight - scrollTop > footerOffsetTop) {
      $firstMenu.addClass('show-scroll-arrow');
    } else {
      $firstMenu.removeClass('show-scroll-arrow');
    }
  };
  $firstMenu.on('scroll resize', handleFirstMenuScroll);

  const $secondMenuContent = $('.second-menu__content');
  function handleSecondMenuScroll($this) {
    const $secondMenu = $this.parent();
    const scrollTop = $this.scrollTop();
    const outerHeight = $this.outerHeight();
    const contentHeight = $this.find('.second-menu__inner').outerHeight();
    const headerHeight = $this.find('.second-menu__header').outerHeight();
    
    console.log($this, scrollTop, outerHeight, contentHeight, headerHeight);

    if (headerHeight + contentHeight - scrollTop > outerHeight) {
      $secondMenu.addClass('show-scroll-arrow');
    } else {
      $secondMenu.removeClass('show-scroll-arrow');
    }
  }
  $secondMenuContent.on('scroll resize', function() { 
    handleSecondMenuScroll($(this));
  });
  $('.first-menu-item').on('mouseenter', function() {
    const $this = $(this);
    setTimeout(function() {
    	const $target = $this.find('.second-menu__content');
  		handleSecondMenuScroll($target);
    });
  })
}(jQuery, window, document));
